// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 535 ? "login" : chunkId) + "." + {"535":"521f9cc0","607":"7af195d1","787":"baa998d2","939":"9bf16c64"}[chunkId] + ".chunk.js";
};